<template>
  <v-card
    class="poll-card rounded-lg mx-auto overflow-y-auto"
    elevation="3"
    :height="vuetifyObject?.height - 95"
  >
    <v-card-item class="pb-1 pt-3">
      <div class="d-flex justify-space-between align-start mb-1">
        <div>
          <!-- <v-chip
            size="x-small"
            color="primary"
            variant="tonal"
            class="font-weight-bold mb-1 mr-2"
            v-if="pollData.category"
          >
            <v-icon start icon="mdi-shape" size="small"></v-icon>
            {{ pollData.category }}
          </v-chip> -->
          <v-chip
            size="x-small"
            :color="
              pollData.poll_status === 'LIVE'
                ? 'success'
                : pollData.poll_status === 'UPCOMING'
                ? 'info'
                : pollData.poll_status === 'COMPLETED'
                ? 'primary'
                : 'warning'
            "
            variant="flat"
            class="font-weight-bold mb-1 text-white"
          >
            <v-icon
              start
              icon="mdi-record-circle-outline"
              size="small"
            ></v-icon>
            {{ pollData.poll_status }}
          </v-chip>
        </div>
        <div class="d-flex flex-column align-end">
          <div class="text-caption text-grey-darken-1 d-flex align-center mb-2">
            <v-icon size="x-small" class="mr-1">mdi-earth</v-icon>
            {{ pollData.target_type }} / {{ pollData.target_value }}
          </div>
        </div>
      </div>
      <div class="d-flex justify-space-between align-start mb-1">
        <div></div>
        <div class="d-flex flex-column align-end">
          <div class="d-flex align-center mt-n1">
            <v-btn
              size="small"
              variant="text"
              color="grey-darken-3"
              prepend-icon="mdi-arrow-left"
              class="text-none font-weight-bold px-2 mr-1"
              @click="$emit('back')"
            >
              Back
            </v-btn>
            <v-btn
              size="small"
              variant="tonal"
              color="primary"
              :disabled="pollData.poll_status !== 'COMPLETED'"
              prepend-icon="mdi-refresh"
              class="text-none font-weight-bold px-3 mr-2"
              @click="$emit('repoll')"
            >
              Repoll
            </v-btn>

            <v-btn
              size="small"
              variant="tonal"
              color="primary"
              prepend-icon="mdi-chevron-left"
              :disabled="!isPreviousPresent"
              class="text-none font-weight-bold px-3 mr-2"
              @click="$emit('previousPoll', returnIndex())"
            >
              Previous
            </v-btn>
            <v-btn
              size="small"
              variant="tonal"
              color="primary"
              :disabled="!isNextPresent"
              append-icon="mdi-chevron-right"
              class="text-none font-weight-bold px-3 mr-2"
              @click="$emit('nextPoll', returnIndex())"
            >
              Next
            </v-btn>
          </div>
        </div>
      </div>

      <v-card-title
        class="text-h6 font-weight-black text-wrap leading-tight mt-1"
      >
        {{ pollData.title }}
      </v-card-title>
      <v-card-subtitle class="text-body-2 mt-1 text-wrap">
        {{ pollData.description }}
      </v-card-subtitle>
    </v-card-item>

    <v-divider class="mx-4 mt-2"></v-divider>

    <v-card-text class="pt-2 pb-2">
      <div class="d-flex justify-end mb-2">
        <v-btn
          size="small"
          variant="text"
          color="primary"
          :prepend-icon="showFilters ? 'mdi-filter-minus' : 'mdi-filter-plus'"
          @click="showFilters = !showFilters"
          class="text-none"
        >
          {{ showFilters ? "Hide Filters" : "Filter Results" }}
        </v-btn>
      </div>

      <v-expand-transition>
        <div
          v-if="showFilters"
          class="bg-grey-lighten-4 pa-3 rounded-lg mb-4 border"
        >
          <v-row dense>
            <v-col cols="6" sm="4">
              <v-autocomplete
                v-model="filters.country"
                label="Country"
                density="compact"
                :items="['ALL', 'India', 'United States']"
                variant="outlined"
                hide-details
                @update:modelValue="onCountryChange"
              ></v-autocomplete>
            </v-col>

            <v-col cols="6" sm="4" v-if="filters.country !== 'ALL'">
              <v-autocomplete
                v-model="filters.state"
                label="State"
                density="compact"
                :items="['ALL', ...availableStates]"
                variant="outlined"
                hide-details
                @update:modelValue="onStateChange"
              ></v-autocomplete>
            </v-col>

            <v-col
              cols="6"
              sm="4"
              v-if="filters.country !== 'ALL' && filters.state !== 'ALL'"
            >
              <v-autocomplete
                v-model="filters.district"
                label="District"
                density="compact"
                :items="['ALL', ...availableDistricts]"
                variant="outlined"
                hide-details
                @update:modelValue="onDistrictChange"
              ></v-autocomplete>
            </v-col>

            <v-col
              cols="6"
              sm="4"
              v-if="
                filters.country !== 'ALL' &&
                filters.state !== 'ALL' &&
                filters.district !== 'ALL'
              "
            >
              <v-autocomplete
                v-model="filters.pincode"
                label="Pincode"
                density="compact"
                :items="['ALL', ...availablePincodes]"
                variant="outlined"
                hide-details
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="4">
              <v-autocomplete
                v-model="filters.age_group"
                label="Age Group"
                density="compact"
                :items="['18-30', '30-50', '50+', 'ALL']"
                variant="outlined"
                hide-details
                placeholder="e.g. 18-25"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <div class="d-flex justify-end mt-3">
            <v-btn
              size="small"
              color="primary"
              @click="applyFilters(false)"
              :loading="isFiltering"
            >
              Apply Filters
            </v-btn>
            <v-btn
              size="small"
              variant="text"
              class="ml-2"
              @click="resetFilters"
            >
              Reset
            </v-btn>
          </div>
        </div>
      </v-expand-transition>

      <div class="mb-4">
        <div class="d-flex justify-space-between align-center mb-3">
          <span class="text-body-2 font-weight-bold text-grey-darken-2">
            {{
              showFilters && hasActiveFilters
                ? "Filtered Results"
                : "Current Results"
            }}
          </span>
          <v-chip
            size="x-small"
            variant="outlined"
            color="primary"
            class="font-weight-bold"
          >
            Total Votes: {{ computedTotalVotes }}
          </v-chip>
        </div>

        <div
          v-for="option in mappedOptions"
          :key="option.optionId"
          class="mb-3"
        >
          <div class="d-flex justify-space-between mb-1 text-caption">
            <span class="font-weight-medium text-truncate mr-2">{{
              option.text
            }}</span>
            <span class="font-weight-bold flex-shrink-0">
              {{ option.percentage }}% ({{ option.votes }})
            </span>
          </div>
          <v-progress-linear
            :model-value="option.percentage"
            color="primary"
            bg-color="info"
            height="8"
            rounded
          ></v-progress-linear>
        </div>
      </div>

      <v-row
        dense
        class="text-caption text-grey-darken-2 bg-grey-lighten-4 pa-1 rounded border-sm mx-0"
      >
        <v-col cols="12" sm="6" class="d-flex align-center py-1">
          <v-icon size="x-small" class="mr-1">mdi-calendar-start</v-icon>
          <strong>Start:</strong> &nbsp; {{ formatDate(pollData.start_time) }}
        </v-col>
        <v-col cols="12" sm="6" class="d-flex align-center justify-sm-end py-1">
          <v-icon size="x-small" class="mr-1">mdi-calendar-end</v-icon>
          <strong>End:</strong> &nbsp; {{ formatDate(pollData.end_time) }}
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions class="px-4 pb-3 pt-0">
      <v-btn
        v-if="pollData.knowledge_base_url"
        :href="pollData.knowledge_base_url"
        target="_blank"
        color="info"
        variant="tonal"
        prepend-icon="mdi-information-outline"
        size="small"
        class="text-none font-weight-bold rounded-lg"
      >
        Learn More
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { GetDemographicVoteDetails } from "@/mixins/Polls/GetDemographicVoteDetails";

export default {
  name: "PollDetailsCard",
  emits: ["back", "repoll", "previousPoll", "nextPoll"], // ADDED EMITS HERE
  props: {
    pollData: {
      type: Object,
      required: true,
    },
    internalPincodes: {
      type: Array,
      default: () => [],
    },
    vuetifyObject: {
      type: Object,
      default: () => ({}),
    },
    pollList: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [GetDemographicVoteDetails],
  data() {
    return {
      showFilters: false,
      isFiltering: false,
      hasActiveFilters: false,
      filteredVoteCounts: null,
      filters: {
        country: "ALL",
        state: "ALL",
        district: "ALL",
        pincode: "ALL",
        age_group: "ALL",
      },
    };
  },
  computed: {
    isPreviousPresent() {
      const ind = this.pollList.findIndex(
        (poll) => poll.pollId == this.pollData.pollId,
      );
      if (ind != -1 && ind > 0) {
        return true;
      }
      return false;
    },
    isNextPresent() {
      const ind = this.pollList.findIndex(
        (poll) => poll.pollId == this.pollData.pollId,
      );
      if (ind != -1 && ind < this.pollList.length - 1) {
        return true;
      }
      return false;
    },
    availableStates() {
      if (!this.internalPincodes || this.filters.country === "ALL") return [];

      const states = new Set(
        this.internalPincodes
          // Filter by the selected country first!
          .filter((item) => item.Country === this.filters.country)
          .map((item) => item.StateName),
      );
      return Array.from(states).filter(Boolean).sort();
    },
    availableDistricts() {
      if (!this.internalPincodes || this.filters.state === "ALL") return [];
      const districts = new Set(
        this.internalPincodes
          .filter((item) => item.StateName === this.filters.state)
          .map((item) => item.District),
      );
      return Array.from(districts).filter(Boolean).sort();
    },
    availablePincodes() {
      if (!this.internalPincodes || this.filters.district === "ALL") return [];
      const pincodes = new Set(
        this.internalPincodes
          .filter(
            (item) =>
              item.District === this.filters.district &&
              item.StateName === this.filters.state,
          )
          .map((item) => item.Pincode),
      );
      return Array.from(pincodes).filter(Boolean).sort();
    },
    activeVoteCounts() {
      return this.hasActiveFilters && this.filteredVoteCounts
        ? this.filteredVoteCounts
        : this.pollData.vote_counts;
    },
    computedTotalVotes() {
      return Object.values(this.activeVoteCounts).reduce(
        (sum, count) => sum + (Number(count) || 0),
        0,
      );
    },
    mappedOptions() {
      return this.pollData.options
        .map((opt) => {
          const votes = this.activeVoteCounts[opt.optionId] || 0;
          const percentage =
            this.computedTotalVotes === 0
              ? 0
              : Math.round((votes / this.computedTotalVotes) * 100);

          return {
            ...opt,
            votes,
            percentage,
          };
        })
        .sort((a, b) => b.votes - a.votes);
    },
  },
  async mounted() {
    this.initDefaultFilters();
  },
  methods: {
    returnIndex() {
      const ind = this.pollList.findIndex(
        (poll) => poll.pollId == this.pollData.pollId,
      );
      if (ind != -1) {
        return ind;
      } else return 0;
    },
    onCountryChange() {
      this.filters.state = "ALL";
      this.filters.district = "ALL";
      this.filters.pincode = "ALL";
    },
    onStateChange() {
      this.filters.district = "ALL";
      this.filters.pincode = "ALL";
    },
    onDistrictChange() {
      this.filters.pincode = "ALL";
    },
    initDefaultFilters() {
      const tType = this.pollData.target_type || "GLOBAL";
      const tVal = this.pollData.target_value || "GLOBAL";

      this.filters.country = "ALL";
      this.filters.state = "ALL";
      this.filters.district = "ALL";
      this.filters.pincode = "ALL";
      this.filters.age_group = this.pollData.age_group || "ALL";

      if (tType === "COUNTRY") {
        this.filters.country = tVal;
      } else if (tType === "STATE") {
        this.filters.country = "INDIA";
        this.filters.state = tVal;
      } else if (tType === "DISTRICT") {
        this.filters.country = "INDIA";
        const loc = this.internalPincodes.find((p) => p.District === tVal);
        if (loc) this.filters.state = loc.StateName;
        this.filters.district = tVal;
      } else if (tType === "PINCODE") {
        this.filters.country = "INDIA";
        const loc = this.internalPincodes.find((p) => p.Pincode === tVal);
        if (loc) {
          this.filters.state = loc.StateName;
          this.filters.district = loc.District;
        }
        this.filters.pincode = tVal;
      }
    },
    async applyFilters(isInitial = false) {
      if (!isInitial) this.isFiltering = true;

      const pollOBJ = {
        pollId: this.pollData.pollId,
        age_group: this.filters.age_group || "ALL",
      };

      pollOBJ.country = this.filters.country || "ALL";

      if (pollOBJ.country !== "ALL") {
        pollOBJ.state = this.filters.state || "ALL";

        if (pollOBJ.state !== "ALL") {
          pollOBJ.district = this.filters.district || "ALL";

          if (pollOBJ.district !== "ALL") {
            pollOBJ.pincode = this.filters.pincode || "ALL";
          }
        }
      }

      try {
        const response = await this.GetDemographicVoteDetailsMethod(pollOBJ);

        if (!response) {
          console.warn("API response is null. Defaulting all counts to 0.");
        }

        let items = null;
        if (response?.data?.items) {
          items = response.data.items;
        } else if (response?.items) {
          items = response.items;
        } else if (response?.data) {
          items = response.data;
        } else if (response) {
          items = response;
        }

        if (Array.isArray(items) && items.length > 0) {
          items = items[0];
        }

        const newCounts = {};

        if (items) {
          // Map valid data if found
          this.pollData.options.forEach((opt) => {
            newCounts[opt.optionId] = Number(items[opt.optionId]) || 0;
          });
        } else {
          // NO DATA FOUND: Force all option counts to exactly 0
          this.pollData.options.forEach((opt) => {
            newCounts[opt.optionId] = 0;
          });
        }

        // Apply the counts (either populated or all 0s)
        this.filteredVoteCounts = { ...newCounts };

        if (!isInitial) {
          this.hasActiveFilters = true;
        }
      } catch (error) {
        console.error("Error fetching demographic details:", error);

        // Failsafe: Also force to 0 if the API call throws an actual error
        const fallbackCounts = {};
        this.pollData.options.forEach((opt) => {
          fallbackCounts[opt.optionId] = 0;
        });
        this.filteredVoteCounts = { ...fallbackCounts };
        if (!isInitial) this.hasActiveFilters = true;
      } finally {
        this.isFiltering = false;
      }
    },
    // async applyFilters(isInitial = false) {
    //   if (!isInitial) this.isFiltering = true;

    //   const pollOBJ = {
    //     pollId: this.pollData.pollId,
    //     age_group: this.filters.age_group || "ALL",
    //   };

    //   pollOBJ.country = this.filters.country || "ALL";

    //   if (pollOBJ.country !== "ALL") {
    //     pollOBJ.state = this.filters.state || "ALL";

    //     if (pollOBJ.state !== "ALL") {
    //       pollOBJ.district = this.filters.district || "ALL";

    //       if (pollOBJ.district !== "ALL") {
    //         pollOBJ.pincode = this.filters.pincode || "ALL";
    //       }
    //     }
    //   }

    //   try {
    //     const response = await this.GetDemographicVoteDetailsMethod(pollOBJ);
    //     if (!response) {
    //       console.error(
    //         "Warning: 'response' is undefined. Ensure your mixin explicitly returns the data payload.",
    //       );
    //     }

    //     let items = null;
    //     if (response?.data?.items) {
    //       items = response.data.items;
    //     } else if (response?.items) {
    //       items = response.items;
    //     } else if (response?.data) {
    //       items = response.data;
    //     } else {
    //       items = response;
    //     }

    //     if (Array.isArray(items) && items.length > 0) {
    //       items = items[0];
    //     }

    //     if (items) {
    //       const newCounts = {};

    //       this.pollData.options.forEach((opt) => {
    //         newCounts[opt.optionId] = Number(items[opt.optionId]) || 0;
    //       });

    //       this.filteredVoteCounts = { ...newCounts };

    //       if (!isInitial) {
    //         this.hasActiveFilters = true;
    //       }
    //     } else {
    //       console.warn("Could not find the 'items' object in the payload.");
    //     }
    //   } catch (error) {
    //     console.error("Error fetching demographic details:", error);
    //   } finally {
    //     this.isFiltering = false;
    //   }
    // },
    resetFilters() {
      this.initDefaultFilters();
      this.hasActiveFilters = false;
      this.filteredVoteCounts = null;
    },
    formatDate(epoch) {
      if (!epoch) return "N/A";
      const date = new Date(epoch);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
  },
};
</script>

<style scoped>
.poll-card {
  border: 1px solid #e0e0e0;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}
.poll-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08) !important;
}
.leading-tight {
  line-height: 1.2 !important;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
